import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { SendCodeResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface SignInGetCodeParams {
  to: string;
}

interface SignInGetCodeRequestParams {
  options?: Omit<
    UseMutationOptions<SendCodeResponse, unknown, SignInGetCodeParams>,
    'queryKey' | 'queryFn'
  >;
}

export const useSignInGetCodeRequest = ({
  options,
}: SignInGetCodeRequestParams = {}) => {
  const api = useApiInstance()
  return useMutation(
    async ({ to }: SignInGetCodeParams) => {
      const { data } = await api.v1AdminUsersSignInSendCodePost({ to })
      return data as SendCodeResponse
    },
    { ...options },
  )
}
